import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface OrganizationLoadingOverlayProps {
  isLoading: boolean;
  organizationName?: string;
}

export const OrganizationLoadingOverlay: React.FC<OrganizationLoadingOverlayProps> = ({ 
  isLoading, 
  organizationName 
}) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm mx-4">
        <div className="flex flex-col items-center">
          <LoadingSpinner size="lg" />
          <h3 className="text-lg font-semibold text-gray-900 mt-4">
            Switching Organization
          </h3>
          {organizationName && (
            <p className="text-sm text-gray-600 mt-2 text-center">
              Loading data for <span className="font-medium">{organizationName}</span>
            </p>
          )}
          <p className="text-xs text-gray-500 mt-1">
            This may take a moment...
          </p>
        </div>
      </div>
    </div>
  );
};